import { Button, ButtonProps } from '@mui/material';
import { Link, LinkProps } from 'react-router-dom';

const ButtonLink: React.FC<ButtonProps & LinkProps> = ({ to, ...rest }): React.ReactElement => (
	<Button component={Link} to={to} {...rest} className="no-print" />
);

export default ButtonLink;
